import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { HStack, Image, Link, Radio, Text, VStack } from '@chakra-ui/react'
import loadingSpinner from 'assets/lottie/loader_wicar.gif'
import { usePayment } from 'context'
import { PaymentCreateSubscription, PaymentCreateType } from 'context/Payment/paymentTypes'
import { PaymentRenewType, PaymentSubscriptionType } from 'context/types'
import { PAYMENT_SCHEMA_SUBSCRIPTION } from 'context/validations'
import dayjs from 'dayjs'
import { Formik } from 'formik'
import { themeColors } from 'theme'

import { CardBody, CardContainer } from 'components/CustomCard'
import CustomDivider from 'components/CustomDivider'
import { SubmitButton } from 'components/InputCustom'
import { CheckboxControl } from 'components/InputCustom/CheckboxControl'
import RadioControl from 'components/InputCustom/RadioControl'
import { CheckmarkIcon } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'
import formatter from 'utils/helpers/formatter'

type ContractSubscriptionNavigateProps = { subscription: PaymentSubscriptionType }

export const ContractSubscription = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const refButton = useRef<HTMLButtonElement>()
  const refForm = useRef<HTMLFormElement>()
  const { createPayment, clearError, checkClientCard, createSubscription,
    paymentState: { loading, error, state: {
      isPaidInstallation,
      paymentOptions: { loading: paymentLoading, data: { anualPayment, firstPayment, onlyRenew, installation } },
      cardOptions: { data: cardInformation, loading: isCardLoading },
    } }
  } = usePayment()
  const [subscription, setSubscription] = useState<PaymentSubscriptionType | null>(null)
  const [isChecked, setIsChecked] = useState<boolean>(false)

  const { icon: { successIconColor } } = themeColors

  const initialValues: PaymentRenewType = {
    radioGroup: 'YES',
    acceptConditions: false
  }

  useEffect(() => {
    let subscription = null

    if (location.state) ({ subscription } = location.state as ContractSubscriptionNavigateProps)

    subscription && setSubscription(subscription)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  useEffect(() => {
    if (subscription?.subscriptionType === 'SOLO-SUSCR') checkClientCard()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription])

  const handleOnSubmit = async ({ radioGroup }: PaymentRenewType) => {
    if (subscription) {
      const { billing, subscriptionType, vehicle, vin } = subscription

      const data: PaymentCreateType = {
        totalAmount:
        subscriptionType === 'SOLO-SUSCR'
          ? onlyRenew.amount ?? '0'
          : subscriptionType === 'SUSCR-RENOV'
            ? anualPayment.amount ?? '120000'
            : firstPayment.amount ?? '319990',
        amount: subscriptionType === 'SOLO-SUSCR'
          ? onlyRenew.amount ?? '0'
          : subscriptionType === 'SUSCR-RENOV'
            ? anualPayment.amount ?? '120000'
            : isPaidInstallation
              ? installation.amount ?? '319990'
              : firstPayment.amount ?? '319990',
        aptNumber: billing?.towerApartmentHouse ?? '',
        branch: '',
        commune: billing?.commune ?? '',
        idVehicle: vehicle?.id ?? '',
        number: billing?.streetNumber ?? '',
        street: billing?.street ?? '',
        subscriptionType,
        IsAutomaticRenewal: subscriptionType === 'SOLO-SUSCR' ? true : radioGroup === 'YES',
        plateNumber: vin?.substring(0, 6) ?? '',
        vin: vin ?? '',
        origin: 2,
      }

      const res = await createPayment(data)

      if (error === '' && res) {
        const { kaufmannPaymentUrl } = res

        if (kaufmannPaymentUrl && /^https?:\/\//.test(kaufmannPaymentUrl)) {
          refForm.current && (refForm.current.action = kaufmannPaymentUrl)
          refButton.current?.click()
        } else
          customToast.showToast({
            description: kaufmannPaymentUrl || 'URL de pago inválida',
            status: 'error'
          })

      }
    }
  }

  const handleOnlySubscription = async () => {
    if (subscription) {
      const { vehicle } = subscription

      const data: PaymentCreateSubscription = {
        lastDigits: cardInformation?.lastDigits ?? '',
        vehicleId: vehicle?.id ?? '',
      }

      const isSubscriptionCreated = await createSubscription(data)

      navigate(`/payment-result/${vehicle?.plateNumber}/yes/no/no/${isSubscriptionCreated ? 'OK' : 'NOK'}`)
    }
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={
          subscription?.subscriptionType === 'SOLO-SUSCR' && cardInformation
            ? handleOnlySubscription
            : handleOnSubmit
        }
        validationSchema={PAYMENT_SCHEMA_SUBSCRIPTION}>
        {({ values }) => (
          <CardContainer isScreen title='Activa la renovación automática' hiddenStack={false}>
            {isCardLoading
              ?
              <VStack alignItems='center' w='100%'>
                <Image
                  w={'120px'}
                  h={'120px'}
                  alt={'loading_wicar'}
                  src={loadingSpinner}
                />
              </VStack>
              :
              <>
               {/*  <CardBody isBorder>
                  <VStack w='full' alignItems='flex-start'>
                    <HStack
                      w='max-content'
                      mt={2}
                      px={2}
                      spacing={2}
                      justifyContent={'center'}
                      alignItems={'center'}
                      borderRadius={'full'}
                      bg={'transparent'}
                      borderWidth={1}
                      borderColor={'gray.700'}>
                      <CheckmarkIcon size={5} fill={successIconColor} />
                      <Text variant={'BTN'}>RECOMENDADO</Text>
                    </HStack>
                    <Text variant='MD_SB'>
                      {subscription?.subscriptionType !== 'SOLO-SUSCR'
                        ? '¿Deseas activar renovación automática?'
                        : 'Activar renovación automática'
                      }
                    </Text>
                    <Text variant='XS'>
                      {subscription?.subscriptionType !== 'SOLO-SUSCR'
                        ? 'Realizaremos el cobro de manera automática en tu tarjeta cuando caduque la vigencia de tu'
                        + ' suscripción actual'
                        : 'Esto significa que realizaremos el cobro de manera automática a tu tarjeta cuando caduque'
                        + ' la vigencia de tu suscripción actual'
                      }
                    </Text>
                    {cardInformation && subscription?.subscriptionType === 'SOLO-SUSCR' &&
                      <HStack
                        w='full'
                        alignItems='center'
                        justifyContent='space-evenly'
                        h={{ base: '120px', sm: '200px', md: '140px' }}>
                        <VStack
                          flex={1}
                          py={10}
                          px={5}
                          alignSelf='stretch'
                          bgColor='gray.500'
                          justifyContent='center'
                          alignItems='flex-start'
                          borderRadius={12}>
                          <Text>{`**** **** **** ${cardInformation.lastDigits ?? 9847}`}</Text>
                        </VStack>
                        <VStack alignItems='flex-start' flex={1}>
                          <VStack alignItems='flex-start'>
                            <Text variant='MD_SB'>Plan premium</Text>
                            <Text variant='XS'>(renovación)</Text>
                          </VStack>
                          <VStack alignItems='flex-start'>
                            <HStack>
                              <Text variant='MD_SB'>Valor</Text>
                              <Text variant='MD_SB'>
                                {formatter.format(parseInt(anualPayment.amount ?? '120000'))}
                              </Text>
                            </HStack>
                            <Text variant='XS'>(IVA incluido)</Text>
                          </VStack>
                        </VStack>
                      </HStack>
                    }
                    <VStack alignItems='flex-start' w='full'>
                      {subscription?.subscriptionType !== 'SOLO-SUSCR' &&
                        <RadioControl name="radioGroup" stackProps={{ alignItems: 'flex-start' }}>
                          <Radio value="YES">Si</Radio>
                          <CustomDivider />
                          <Radio value="NO">No</Radio>
                        </RadioControl>
                      }
                      {(subscription?.subscriptionType === 'SOLO-SUSCR' || values.radioGroup === 'YES') &&
                        <Text variant='XS'>
                          {'Fecha de cobro próxima renovación automática: '
                            + `${subscription?.paymentDate && dayjs(subscription?.paymentDate) > dayjs()
                              ? dayjs(subscription?.paymentDate)
                                .add(subscription?.subscriptionType === 'SOLO-SUSCR' ? 0 : 1, 'y')
                                .format('DD MMMM YYYY')
                              : 'un año después del inicio de tu servicio'}`
                          }
                        </Text>
                      }
                    </VStack>
                  </VStack>
                </CardBody> */}
                <CardBody isBorder>
                  <VStack>
                    <Text variant='MD_SB' textAlign='center'>Términos y condiciones aplican</Text>
                    <CheckboxControl name='acceptConditions' onChange={() => setIsChecked(!isChecked)}>
                      <Text>
                        Acepto los <Link textDecoration='underline' href='https://www.wicar.cl/terminos-y-condiciones/'>
                          términos y condiciones</Link>
                      </Text>
                    </CheckboxControl>
                  </VStack>
                </CardBody>
                <SubmitButton
                  isLoading={loading || paymentLoading}
                  minWidth={{ base: '80%', md: '460px' }}
                  fontSize='small'
                  disabled={loading || paymentLoading || !isChecked}
                  loadingText={paymentLoading
                    ? 'Cargando ...' : cardInformation && subscription?.subscriptionType === 'SOLO-SUSCR'
                      ? 'Activando tu renovación...' : 'Procesando tu pago...'}>
                  {subscription?.subscriptionType === 'SOLO-SUSCR'
                    ? 'ACTIVAR RENOVACIÓN AUTOMÁTICA'
                    : subscription?.subscriptionType === 'SUSCR-RENOV'
                      ? `ir a pagar ${formatter.format(parseInt(anualPayment.amount ?? '120000'))}`
                      : `ir a pagar ${formatter.format(parseInt(
                        (isPaidInstallation ? installation.amount : firstPayment.amount) ?? '319990'
                      ))}`}
                </SubmitButton>
              </>
            }
          </CardContainer>
        )}
      </Formik>
      <form
        method='GET'
        style={{ display: 'none' }}
        ref={ref => ref && (refForm.current = ref)}
      >
        <button type='submit' ref={ref => ref && (refButton.current = ref)}></button>
      </form>
    </>
  )
}
